const actions = {
  ADD_BEGIN: 'ADD_BEGIN',
  ADD_SUCCESS: 'ADD_SUCCESS',
  ADD_ERR: 'ADD_ERR',

  READ_BEGIN: 'AGENTS_READ_BEGIN',
  READ_SUCCESS: 'AGENTS_READ_SUCCESS',
  READ_ERR: 'AGENTS_READ_ERR',

  DELETE_BEGIN: 'DELETE_BEGIN',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_ERR: 'DELETE_ERR',

  UPDATE_BEGIN: 'UPDATE_BEGIN',
  UPDATE_SUCCESS: 'UPDATE_SUCCESS',
  UPDATE_ERR: 'UPDATE_ERR',

  AddBegin: () => {
    return {
      type: actions.ADD_BEGIN,
    };
  },

  AddSuccess: (data) => {
    return {
      type: actions.ADD_SUCCESS,
      data,
    };
  },

  AddErr: (err) => {
    return {
      type: actions.ADD_ERR,
      err,
    };
  },

  ReadBegin: () => {
    return {
      type: actions.READ_BEGIN,
    };
  },

  ReadSuccess: (data) => {
    return {
      type: actions.READ_SUCCESS,
      data,
    };
  },

  ReadErr: (err) => {
    return {
      type: actions.READ_ERR,
      err,
    };
  },

  UpdateBegin: () => {
    return {
      type: actions.UPDATE_BEGIN,
    };
  },

  UpdateSuccess: (data) => {
    return {
      type: actions.UPDATE_SUCCESS,
      data,
    };
  },

  UpdateErr: (err) => {
    return {
      type: actions.UPDATE_ERR,
      err,
    };
  },

  DeleteBegin: () => {
    return {
      type: actions.DELETE_BEGIN,
    };
  },

  DeleteSuccess: (data) => {
    return {
      type: actions.DELETE_SUCCESS,
      data,
    };
  },

  DeleteErr: (err) => {
    return {
      type: actions.DELETE_ERR,
      err,
    };
  },
};

export default actions;
